import { Item } from '../../domain/item';
import {
  RapidCaptureRecord,
  hasCaptureEdits,
  hasPendingCaptureAI,
} from './rapidCaptureTypes';

export const isMatchingRapidCaptureItem = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): item is Item =>
  Boolean(
    item &&
    item.id === record.itemId &&
    item.collectionId === record.collectionId &&
    (record.mutation || item.captureOperationId === record.operationId),
  );

export const isRapidCaptureAuthoritativelyConfirmed = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): boolean =>
  isMatchingRapidCaptureItem(record, item) && record.state === 'confirming';

export const shouldReconcileRapidCaptureRecord = (
  record: RapidCaptureRecord,
  item: Item | undefined,
): boolean => {
  // Keep the local image/card until the inventory reader has observed publication
  // AND every edit and AI phase is finished. A receipt alone would cause a gap.
  return (
    record.schemaVersion === 6 &&
    record.itemCreated &&
    Boolean(record.completion) &&
    !hasCaptureEdits(record) &&
    !hasPendingCaptureAI(record) &&
    !Object.values(record.editorLeases ?? {}).some(
      (expiry) => expiry > Date.now(),
    ) &&
    isRapidCaptureAuthoritativelyConfirmed(record, item) &&
    (item?.revision ?? -1) >= (record.itemRevision ?? 0)
  );
};
